import { doRequest, applyFilters } from "./helpers";

const ApiKeyService = {
  list: (filters = {}) => {
    let path = "/admin/api_keys";
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  },

  create: data => {
    return doRequest("POST", "/admin/api_keys", { data });
  },

  get: id => {
    return doRequest("GET", `/admin/api_keys/${id}`);
  },

  rotate: id => {
    return doRequest("POST", `/admin/api_keys/${id}/rotate`);
  },

  revoke: id => {
    return doRequest("POST", `/admin/api_keys/${id}/revoke`);
  },
};

export default ApiKeyService;
